import type { ReactNode } from 'react'
import { StepRowBadge } from '../steps/StepsToRebalanceAccordionBody'

type PlanImportantNoteCardProps = {
  notePoints: ReactNode[]
}

export function PlanImportantNoteCard({ notePoints }: PlanImportantNoteCardProps) {
  return (
    <div className="px-5 pt-6">
      <div
        className="relative flex flex-col gap-4 rounded-xl border border-[#F0F4F7] bg-white bg-no-repeat bg-right-top px-4 pb-6 pt-5"
        style={{ backgroundImage: "url('/images/bg-cover-curves.png')" }}
      >
        <div className="text-[13px] font-[500] leading-[130%] text-[#3D3D3D]">Important Note</div>
        {notePoints.map((notePoint, pointIndex) => (
          <div key={`important-note-${pointIndex}`} className="flex items-start gap-4">
            <div className="flex h-7 w-7 shrink-0 items-center justify-center">
              <StepRowBadge index={pointIndex + 1} />
            </div>
            <div>{notePoint}</div>
          </div>
        ))}
      </div>
    </div>
  )
}
